import { PageHeader } from '@/components/ui/PageHeader'
import { PlatformBreadcrumbs } from '../PlatformBreadcrumbs'
import { RedisMenu } from '../RedisMenu'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { BadgesSection } from './BadgesSection'
import { ButtonsSection } from './ButtonsSection'
import { DesignSystemSection } from './DesignSystemSection'
import { IconsSection } from './IconsSection'
import { PictogramsSection } from './PictogramsSection'
import { ToastsSection } from './ToastsSection'

function PlatformDesignSystemPageContent() {
  return (
    <TablePageContainer>
      <div className="h-full overflow-y-auto">
        <div className="space-y-6 p-6">
          <div>
            <h2 className="text-lg font-semibold">Design system</h2>
            <p className="text-sm text-muted-foreground">
              Shared UI components, variants, and interaction patterns used across the platform.
            </p>
          </div>

          <div className="divide-y divide-border overflow-hidden rounded-lg border border-border bg-offwhite">
            <DesignSystemSection
              title="Icons"
              description="Browse platform icons — click any icon to copy its name to the clipboard."
              contentClassName="p-0"
            >
              <IconsSection />
            </DesignSystemSection>
            <DesignSystemSection
              title="Pictograms"
              description="Browse platform pictograms — click any pictogram to copy its name to the clipboard."
              contentClassName="p-0"
            >
              <PictogramsSection />
            </DesignSystemSection>
            <DesignSystemSection
              title="Buttons"
              description="Brand-aligned interaction states from the shared shadcn Button component."
            >
              <ButtonsSection />
            </DesignSystemSection>
            <DesignSystemSection title="Badges" description="Compact labels for status, metadata, and categorisation.">
              <BadgesSection />
            </DesignSystemSection>
            <DesignSystemSection title="Toasts" description="Transient feedback notifications powered by Sonner.">
              <ToastsSection />
            </DesignSystemSection>
          </div>
        </div>
      </div>
    </TablePageContainer>
  )
}

export function PlatformDesignSystemPage() {
  return (
    <>
      <PageHeader className="pr-3" title={<PlatformBreadcrumbs title="Design system" />}>
        <RedisMenu />
      </PageHeader>
      <PlatformDesignSystemPageContent />
    </>
  )
}
